import { ButtonProps } from '../../atoms/Button';
import { DividerProps } from '../../atoms/Divider';
import { TextProps } from '../../atoms/Text';


type CreateCourseHeaderInternalProps = {
  text?: TextProps;
  button?: ButtonProps;
  divider?: DividerProps;
};

type CreateCourseHeaderPropsValues = {
  '': CreateCourseHeaderInternalProps;
};

const propValues: CreateCourseHeaderPropsValues = {
  '': {
    text: {
      style: 'Bold',
      align: 'Left',
      colour: 'Default',
      type: 'Heading1',
    },
    button: {
      style: 'Text',
      size: 'Small',
      type: 'TextIcon',
      colour: 'PrimaryAction',
      loading: 'Default',
    },
    divider: {
      type: 'Horizontal',
      style: 'Solid',
      colour: 'BorderBase',
    },
  },
};

const getProps = (type: string): CreateCourseHeaderInternalProps => {
  const values: CreateCourseHeaderInternalProps = propValues[type];
  if (!values) {
    console.error(`${type} props not found`);
    return {};
  }
  return values;
};

export default getProps;
